<template>
  <div class="container">
    <Header title="GBB电瓶扫码" :leftHandler="leftHandler" />
    <div class="gbb-box">
      <div>
        <img class="bottom-nav-icon-scan" src="../../assets/images/activity/show-w.png">
      </div>
      <div style="font-size:14px; width: 80%;margin-left: 10%;line-height: 20px;">售卖给维修站需扫描彩盒码，彩盒码位于盒子顶端，如上图示；</div>
      <div>
        <button @click="scanCode()" class="button" style="background-color: #117281;">售卖给维修站</button>
      </div>
      <div>
        <img class="bottom-nav-icon-scan" src="../../assets/images/activity/show-c.png">
      </div>
      <div style="font-size:14px;margin-top:10px; width: 80%;margin-left: 10%;line-height: 20px;">售卖给车主需扫描smart code,
        smart code位于产品顶端，如上图示；</div>
      <div>
        <button @click="goToQuality()" class="button" style="background-color: #FFA300;">售卖给车主</button>
      </div>
    </div>
    <div class="margin-bottom"></div>
    <tabbar :active="1"></tabbar>
    <!-- <van-dialog v-model="show" confirmButtonText="我知道了" confirmButtonColor="#54BCBD">
         <div slot="title">
            <van-icon name="warning" color="#BD3124" size="25px"/>&nbsp;扫码失败
         </div>
         <div slot="default" style="text-align: center;margin:25px;color: #888888;">
           <div>二维码信息不正确，扫码失败</div>
         </div>
        </van-dialog> -->
    <quality-assurance-tray-info v-if="showTrayCode" :trayInfo="trayInfo"
      :showTrayInfo="showTrayInfo"></quality-assurance-tray-info>
  </div>
</template>
<script>
import Header from '@/components/header'
import Tabbar from '@/components/tabbar'
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
import { Toast } from 'vant'
import { userUtils } from '@/utils/auth'
import QualityAssuranceTrayInfo from '../activity/2022/components/quality-assurance-tray-info.vue'
export default {
  components: {
    Header,
    Tabbar,
    QualityAssuranceTrayInfo
  },
  data () {
    return {
      userInfo: {},
      count: '',
      showTrayCode: false,
      showTrayInfo: true,
      trayInfo: {}
    }
  },
  created () {
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.userInfo = userUtils.getClientInfo()
    console.log(this.userInfo)
    if (this.userInfo.channelCode !== '1210') {
      this.$dialog.alert({
        message: '此功能仅向GBB用户开放'
      }).then(() => {
        document.location = process.env.VUE_APP_EXTRA_SITE + '/#/tab/home'
      })
    }
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    // 售卖给维修站扫码
    scanCode () {
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            boxCode: res.resultStr
          }
          this.getLocation(scanData, '1')
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },
    // 售卖给车主扫码
    goToQuality (type, isAgency) {
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData
          if (isAgency) {
            scanData = {
              scanCode: res.resultStr
            }
            this.scanResult(scanData, '', isAgency)
          } else {
            if (type === 'feedback') {
              scanData = {
                warrantyCode: res.resultStr
              }
              this.scanResult(scanData, 'feedback')
            } else {
              scanData = {
                scanCode: res.resultStr
              }
              this.getLocation(scanData, '2')
            }
          }
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
      // this.$router.push({ name: 'quality-assurance-ws', query: { scanAdd: '1' } })
    },
    // 扫码结果
    scanResult (value, type, isAgency) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      if (isAgency) {
        activityApi.qaAgencyScan(value).then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            if (res.data.resultData.warrantyInfo) {
              let result = res.data.resultData.warrantyInfo
              this.$router.push({ name: 'quality-assurance-agency-detail', query: { warrantyId: result.warrantyId, deliveryDate: result.deliveryDate } })
            }
          } else {
            this.$notify({
              background: '#1989fa',
              message: res.data.resultMsg,
              className: 'notify-error-msg'
            })
          }
        }).catch(() => {
          this.$toast.clear()
        })
      } else {
        if (type === 'feedback') {
          activityApi.qaFeedbackScan(value).then(res => {
            this.$toast.clear()
            if (res.data.resultCode === '0') {
              this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: res.data.resultData.electronicWarrantyInfo.warrantyId, type: 'info' } })
              console.log(res.data)
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          }).catch(() => {
            this.$toast.clear()
          })
        } else {
          activityApi.qaScan(value).then(res => {
            this.$toast.clear()
            if (res.data.resultCode === '0') {
              if (res.data.resultData.electronicWarrantyInfo) {
                let result = res.data.resultData.electronicWarrantyInfo
                if (result.warrantyId) {
                  if (result.warrantyStatus === 1) {
                    let data = JSON.stringify(result)
                    sessionStorage.setItem('codeInfo', data)
                    this.$router.push({ name: 'quality-assurance-ws-info', query: { warrantyStatus: '1', warrantyId: result.warrantyId, scanAdd: '1' }, params: { from: 'list' } })
                  } else {
                    this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: result.warrantyId, scanAdd: '1' } })
                  }
                } else {
                  console.log(result)
                  let data = JSON.stringify(result)
                  sessionStorage.setItem('codeInfo', data)
                  this.$router.push({ name: 'quality-assurance-ws-info', query: { scanAdd: '1' } })
                }
              } else if (res.data.resultData.martTrayInfo) {
                this.trayInfo = res.data.resultData.martTrayInfo
                this.showTrayCode = true
                this.trayCodeType = this.trayInfo.trayCode.split('_')[1]
              }
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          }).catch(() => {
            this.$toast.clear()
          })
        }
      }
    },
    // 获取经纬度
    getLocation (scanData, type) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          if (type === '1') {
            this.gbbCodeScan(scanData)
          } else {
            this.scanResult(scanData)
          }
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },
    leftHandler () {
      this.$router.go(-1)
    },
    // 扫码结果
    gbbCodeScan (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.gbbCodeScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          Toast({
            message: '扫码成功，请继续扫码',
            position: 'top'
          })
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style scoped>
.gbb-box {
  position: relative;
  top: 55px;
  width: 95%;
  height: 680px;
  margin: auto;
  border-radius: 10px;
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 100px;
}

.title {
  font-size: 18px;
  position: relative;
  /* padding-top: 24px; */
  font-weight: 600;
  line-height: 60px;
  /* margin-bottom: 16px; */
}

.bottom-nav-icon-scan {
  margin-top: 20px;
  width: 80%;
  height: 200px;
}
.margin-bottom{
  height:40px;
}

.button {
  width: 300px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  margin-top: 20px;
}
</style>
